/**
 * AI 客服相关接口
 */
import ax from '../../axios'

/**
 * 获取 mpmanage 的 satoken（用于 iframe 嵌入素材库）
 * 后端用 weiliao 的 token 换取 mpmanage 的 mp-satoken
 * @returns {*}
 * @private
 * TODO: 替换为后端实际接口路径
 */
export function getBjAiTokenAPI() {
  return ax({
    url: '/wlapi/qimai/sso/token',
    method: 'POST'
  })
}

export function getAiCsTrusteeship(params) {
  // TODO: 替换为后端实际接口路径
  return ax({
    url: '/wlapi/ai/cs-trusteeship',
    method: 'GET',
    params
  })
}

export function toggleAiCsTrusteeship(data) {
  return ax({
    url: '/wlapi/ai/cs-trusteeship/toggle',
    method: 'POST',
    data
  })
}

export function setAiCsGuideProblems(data) {
  return ax({
    url: '/wlapi/ai/guide-problems',
    method: 'POST',
    data
  })
}

export function getAiCsGuideProblems(params) {
  return ax({
    url: '/wlapi/ai/guide-problems',
    method: 'GET',
    params
  })
}

export function delAiCsGuideProblems(data) {
  return ax({
    url: `/wlapi/ai/guide-problems/delete`,
    method: 'POST',
    data
  })
}